<template>
  <div class="cookie-popup">
    <div class="cookie-popup__container">
      <span class="cookie-popup__title">Manage Cookies</span>

      <p class="cookie-popup__text">
        We use various types of cookies: essential, functionality, statistics, and marketing.
        Essential cookies are always on, as they are necessary for the website’s operation.
        You can toggle functionality, statistics, and marketing cookies on and off here and on the Cookie Policy page.
        Please note, disabling some cookies may impact your experience and the services we offer.

        <span class="cookie-popup__text-more">
          For more information, see our
          <router-link
            to="/cookie"
            class="cookie-popup__policy-link">
            Cookie Policy
          </router-link>
        </span>
      </p>
    </div>

    <div class="cookie-popup__container">
      <div class="cookie-popup__toggle">
        <div class="cookie-popup__toggle-item">
          <span class="cookie-popup__toggle-title">Essential</span>

          <p class="cookie-popup__toggle-text">
            Essential cookies are required for the basic functions of this site,
            such as enabling secure login and adjusting your privacy settings.
          </p>

          <ui-switcher
            class="cookie-popup__toggle-switch"
            :value="essentialCookies"
            :rounded="true"
            :disabled="true" />
        </div>

        <div class="cookie-popup__toggle-item">
          <span class="cookie-popup__toggle-title">Functionality</span>

          <p class="cookie-popup__toggle-text">
            Functionality cookies allow us to remember your preferences,
            such as your region or selected options. This information cannot be used to identify you.
          </p>

          <ui-switcher
            v-model="functionalityCookies"
            :rounded="true"
            class="cookie-popup__toggle-switch" />
        </div>

        <div class="cookie-popup__toggle-item">
          <span class="cookie-popup__toggle-title">Statistics</span>

          <p class="cookie-popup__toggle-text">
            Statistics cookies help us understand
            how visitors interact with the website by collecting and reporting information anonymously.
          </p>

          <ui-switcher
            v-model="statisticsCookies"
            :rounded="true"
            class="cookie-popup__toggle-switch booster-on-account-card__switcher" />
        </div>

        <div class="cookie-popup__toggle-item">
          <span class="cookie-popup__toggle-title">Marketing</span>

          <p class="cookie-popup__toggle-text">
            Marketing cookies are used to deliver personalised advertisements and to
            help us analyse the effectiveness of our ad campaigns.
          </p>

          <ui-switcher
            v-model="marketingCookies"
            :rounded="true"
            class="cookie-popup__toggle-switch" />
        </div>
      </div>
    </div>

    <div class="cookie-popup__container">
      <div class="cookie-popup__container-buttons">
        <button
          class="button cookie-popup__button cookie-popup__button--save"
          type="button"
          @click="savePreferences">
          Save preferences
        </button>

        <button
          class="button button-main cookie-popup__button"
          type="button"
          @click="$emit('accept-all')">
          Accept all
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import UiSwitcher from 'Components/ui/Switcher/UiSwitcher.vue';
import yandexMetrika from 'Root/drivers/yandexMetrika';

export default {
  name: 'ManageCookies',

  components: { UiSwitcher },

  data() {
    return {
      essentialCookies: true,
      functionalityCookies: false,
      statisticsCookies: false,
      marketingCookies: false,
    };
  },

  mounted() {
    yandexMetrika.invokeEvent('dma_cookie_settings');
  },

  methods: {
    savePreferences() {
      const params = {
        ad_storage: this.marketingCookies ? 'granted' : 'denied',
        ad_user_data: this.marketingCookies ? 'granted' : 'denied',
        ad_personalization: this.marketingCookies ? 'granted' : 'denied',
        analytics_storage: this.statisticsCookies ? 'granted' : 'denied',
        functionality_storage: this.essentialCookies ? 'granted' : 'denied',
        security_storage: this.essentialCookies ? 'granted' : 'denied',
      };

      this.$emit('save-preferences', params);
    },
  },
};
</script>

<style scoped lang="scss">
.cookie-popup {
  grid-row-gap: 8px;
  max-width: 516px;
}

.cookie-popup__title {
  display: block;
  margin-bottom: 16px;
}

.cookie-popup__toggle {
  display: grid;
  grid-auto-flow: row;
}

.cookie-popup__toggle-item {
  display: grid;
  grid-template-areas: 'toggle-title toggle-switch'
                       'toggle-text toggle-switch';
  grid-column-gap: 16px;
  grid-row-gap: 8px;
  border-bottom: 1px solid $color--basic-menu;
  padding: 16px 0;

  &:last-child {
    border-bottom: none;
  }
}

.cookie-popup__toggle-title {
  grid-area: toggle-title;
  font-size: 15px;
  font-weight: 500;
}

.cookie-popup__toggle-text {
  grid-area: toggle-text;
  font-size: 11px;
  font-weight: 300;
}

.cookie-popup__toggle-switch {
  grid-area: toggle-switch;
}

.cookie-popup__text-more {
  display: block;
  margin-top: 6px;
}

.cookie-popup__container-buttons {
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 16px;
  grid-template-columns: repeat(2, auto);
  grid-template-areas: "save accept";
  justify-content: end;

  .button {
    &:first-child {
      grid-area: save;
    }

    &:last-child {
      grid-area: accept;
    }
  }
}

.cookie-popup__button {
  font-size: 15px;
  padding: 15px;
}

.cookie-popup__button--save {
  border: 1px solid $color--basic-green;
}

@media screen and #{$screen-less-than-640} {
  .cookie-popup {
    overflow-y: auto;
    max-height: 100vh;
    right: 40px;
  }
}

@media screen and #{$screen-less-than-480} {
  .cookie-popup__button {
    width: 100%;
    padding: 0;
  }

  .cookie-popup__container-buttons {
    grid-template-areas: "save save"
                         "accept accept";
  }
}
</style>
